import { UserDataState } from '@store/users/user.firestore.reducer';
import { createFeatureSelector } from '@ngrx/store';
import { FIRESTORE_COLLECTION_USERS } from '@store/firestore/allFirestoreCollections';

export const userDataState = createFeatureSelector<UserDataState>(FIRESTORE_COLLECTION_USERS);
